import React, { Component } from 'react';
import successLogo from './../../../../../statics/img/jazzcash/success.png';
import failLogo from './../../../../../statics/img/esaypaisa/fail.svg';
import pendingLogo from './../../../../../statics/img/esaypaisa/pending.svg';
import './JazzCash.css';

class JazzCashStatus extends Component {
    
    componentDidMount (){
        setTimeout(()=>{
            if(this.props.status_message == "Transaction abandoned."){
                window.history.back();
            }else{
                window.location.href = this.props.redirection_url;
            }
            
        },3000)
    }

    renderSuccess = () => (
        <div>
            <img src={successLogo} />
            <h4>Transaction Successful.</h4>
            <p>{this.props.status_message}</p>
        </div>
    )

    renderFail = () => (
        <div>
            <img src={failLogo} />
            <h4>Payment failed</h4>
            <p>{this.props.status_message}</p>
        </div>
    )

    renderPending = () => (
        <div>
            <img src={pendingLogo} />
            <h4>Payment pending</h4>
            <p>{this.props.status_message}</p>
        </div>
    )

    render() {
        return (
            <div className="jazzcash_content jazzcash_status">
                {this.props.jazzcash_status == "success" && this.renderSuccess()}
                {this.props.jazzcash_status == "fail" && this.renderFail()}
                {this.props.jazzcash_status == "pending" && this.renderPending()}
            </div>
        )
    }
}
export default JazzCashStatus;